import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/super-admin/")({
  component: () => <div>Hello /_authenticated/super-admin/!</div>,
});
